import React from 'react';
import './FreelanceServices.css';
import { FaLaptopCode} from 'react-icons/fa';

const services = [
  {
    title: "Website Development",
    icon: <FaLaptopCode />,
    description: "Creating custom websites for small businesses to improve their online presence.",
  },
  
  // You can add more services here
];

const FreelanceServices: React.FC = () => {
  return (
    <div className="services-container">
      <h3 className="services-title">🛠 Services I Provide</h3>
      <p className="services-intro">Freelancing solutions ranging from tech projects to home maintenance.</p>

      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card" style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}>
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-desc">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FreelanceServices;
